module.exports = __webpack_public_path__ + "img/DESIGN_07_prew.1d321c06.jpg";